import { render, staticRenderFns } from "./PromotionRowOfferPresentation.vue?vue&type=template&id=6c4807ee&scoped=true"
import script from "./PromotionRowOfferPresentation.vue?vue&type=script&lang=ts&setup=true"
export * from "./PromotionRowOfferPresentation.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PromotionRowOfferPresentation.vue?vue&type=style&index=0&id=6c4807ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4807ee",
  null
  
)

export default component.exports